import { render, staticRenderFns } from "./AddFolderItemPop.vue?vue&type=template&id=6f2a3d1d&scoped=true&"
import script from "./AddFolderItemPop.vue?vue&type=script&lang=js&"
export * from "./AddFolderItemPop.vue?vue&type=script&lang=js&"
import style0 from "./AddFolderItemPop.vue?vue&type=style&index=0&id=6f2a3d1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a3d1d",
  null
  
)

export default component.exports